import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { merge, of, switchMap } from 'rxjs';

import { CompanyActions } from '@public-page/store/company';
import { AuthorizationLocalStorageActions } from '@modules/authorization/store/auth';

@Injectable()
export class InitEffects {
  constructor(private actions$: Actions) {}

  init$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => merge(of(CompanyActions.load()), of(AuthorizationLocalStorageActions.loadAuthToken())))
    );
  });
}
